import {
  getIframeTheme,
  type IframeTheme,
  setIframeQuery,
} from '../../../helpers/iframe';

export type Theme = IframeTheme;

export const isTheme = (theme?: string | null): theme is Theme =>
  theme === 'light' || theme === 'dark';

export const normalizeTerminalHost = (terminalHost?: string) => {
  const host = terminalHost?.trim();

  if (!host) return null;

  return /^https?:\/\//i.test(host) ? host : `https://${host}`;
};

export const getCurrentTheme = (configTheme?: Theme): Theme =>
  getIframeTheme(configTheme || 'dark');

export type TerminalIframeUrlOptions = {
  appPath?: boolean;
  mode?: string;
};

export const getTerminalIframeUrl = (
  terminalHost: string | undefined,
  fileId: number,
  lang: string,
  theme?: Theme,
  options?: TerminalIframeUrlOptions
) => {
  const normalizedTerminalHost = normalizeTerminalHost(terminalHost);

  if (!normalizedTerminalHost) return null;

  const url = new URL(normalizedTerminalHost);

  if (options?.appPath) {
    const basePath = url.pathname.replace(/\/$/, '');
    url.pathname = `${basePath}/app/`;
  }

  const themeType = getCurrentTheme(theme);

  url.searchParams.set('id', fileId.toString());
  setIframeQuery(url, lang, themeType);
  url.searchParams.set('theme', themeType);

  if (options?.mode) {
    url.searchParams.set('mode', options.mode);
  }

  return url.toString();
};
